import { Component, Input, OnInit, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-view-customer-remark',
    templateUrl: './view-customer-remark.component.html',
    styleUrls: ['./view-customer-remark.component.scss'],
    standalone: false
})
export class ViewCustomerRemarkComponent implements OnInit {
  private activeModal = inject(NgbActiveModal);

  @Input() viewCustomerId: number;
  @Input() viewCustomerName: string;
  ngOnInit(): void {
  }


  reset() {
    this.activeModal.close();
  }
}
